import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class AntecedentesSiniestralesServices {

  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async obtenerDatosAntecedentes(idDenuncia) {
    try {
      const antecedentesData = await this.apiService.fetchDatosAntecedentes(idDenuncia)
      return antecedentesData
    } catch (error) {
      console.error("Error obteniendo datos de los antecedentes", error)
      return []
    }
  }
}  

export default AntecedentesSiniestralesServices
